import { combineCallbacks, getLastDefinedProperty, mergeEntityCollections, shallowEqual, } from "./utils/mod.js";
/**
 * @alpha
 */
export class ObjectMerger {
    #memoCallCounter = 0;
    #memo = new Map();
    #tools = {
        callback: this.#memoizeTool("callback", combineCallbacks),
        // prettier-ignore
        entityCollection: this.#memoizeTool("entityCollection", mergeEntityCollections),
        property: this.#memoizeTool("property", getLastDefinedProperty),
    };
    #getToolCalls(toolName) {
        let toolCalls = this.#memo.get(toolName);
        if (!toolCalls) {
            toolCalls = new Map();
            this.#memo.set(toolName, toolCalls);
        }
        return toolCalls;
    }
    #memoizeTool(toolName, mergeTool) {
        return ((...args) => {
            const callCounter = this.#memoCallCounter++;
            const toolCalls = this.#getToolCalls(toolName);
            const previousCall = toolCalls.get(callCounter);
            const shouldUsePreviousCall = previousCall && shallowEqual(previousCall.args, args);
            if (shouldUsePreviousCall) {
                return previousCall.result;
            }
            const result = mergeTool(...args);
            toolCalls.set(callCounter, { toolName, args, result });
            return result;
        });
    }
    #previousResult;
    merge(work) {
        this.#memoCallCounter = 0;
        const result = work(this.#tools);
        if (this.#previousResult && shallowEqual(this.#previousResult, result)) {
            return this.#previousResult;
        }
        this.#previousResult = result;
        return result;
    }
}
